import { ActionIcon, Box, Flex, Modal, Stack, Text, TextInput } from '@mantine/core';
import { IconPlus as AddIcon } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Article } from '@/module/Author/Article';
import { ArticleCard } from '@/module/Author/Article/components/Card/ArticleCard';

import { NoContentPlaceholder } from '@/core/components';

import { useFilterAvailable } from './hooks/useFilterAvailable';

interface CriteriaArticleSelectAddModalProps {
  available: Article[];
  selected: Article[];

  close: () => void;
  onAdd: (article: Article) => void;
}

export function CriteriaArticleSelectAddModal({
  available,
  selected,
  close,
  onAdd,
}: CriteriaArticleSelectAddModalProps) {
  const { t } = useTranslation();
  const { searchProps, options } = useFilterAvailable({ available, selected });

  return (
    <Modal
      size="70vw"
      opened
      onClose={close}
      withCloseButton={false}
    >
      <Box p="sm">
        <Text
          fw="500"
          size="lg"
        >
          Articole
        </Text>
        <TextInput
          label="caută după titlu și autori"
          {...searchProps}
        />
      </Box>
      <Box
        mah="70vh"
        style={{ overflow: 'scroll' }}
      >
        {options.length === 0 && <NoContentPlaceholder title="Nu exista date" />}
        <Stack p="sm">
          {options.map(article => (
            <Flex
              align="center"
              key={article.id}
            >
              <ActionIcon
                mr="5px"
                onClick={() => onAdd(article)}
                variant="filled"
                aria-label={t('button.add')}
              >
                <AddIcon
                  style={{ width: '70%', height: '70%' }}
                  stroke={1.5}
                />
              </ActionIcon>
              <ArticleCard
                article={article}
                onClick={() => window.open(`/author/article/${article.id}`)}
              />
            </Flex>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
}
